<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>{{ $t('signin_title') }}</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <v-layout column>
          <form @submit.prevent="userSignMeIn">
            <v-flex>
              <v-alert type="error" dismissible v-model="alert">{{ error }}</v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required
              ></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                required
              ></v-text-field>
            </v-flex>
            <v-flex class="text-xs-center" mt-5>
              <v-btn color="primary" type="submit">{{ $t('signin_submit') }}</v-btn>
              <!--<v-btn color="secondary" @click="$router.push('/signup')">Sign Up</v-btn>-->
              <v-btn
                color="secondary"
                @click="$router.push('/resetpassword')"
              >{{ $t('signin_reset_password') }}</v-btn>
            </v-flex>
          </form>
          <v-flex class="text-xs-center" mt-5 v-if="config.components.googlelogin">
            <v-btn color="secondary" @click="userSignMeInWithGoogle()">{{ $t('signin_google') }}</v-btn>
            <span>You have to assign your account in your user settings first!</span>
          </v-flex>
          <v-flex class="text-xs-center" mt-5 v-if="config.components.azurelogin && adminview">
            <v-btn color="secondary" @click="userSignMeInWithAzure()">{{ $t('signin_azure') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<i18n>
  {
    "de": {
      "signin_title" : "Login",
      "signin_submit" : "Login",
      "signin_google" : "Login mit Google",
      "signin_azure" : "Login mit Azure",
      "signin_reset_password" : "Passwort zurücksetzen"
    },
    "en": {
      "signin_title" : "Sign In",
      "signin_submit" : "Sign In",
      "signin_google" : "Sign in with Google",
      "signin_azure" : "Sign in with Azure",
      "signin_reset_password" : "Reset Password"
    }
  }
</i18n>

<script>
import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/users";
import { api as confApi } from "@/store/modules/configuration";

export default {
  data() {
    return {
      email: "",
      password: "",
      alert: false
    };
  },
  computed: {
    ...mapGetters(confApi.namespace, [confApi.getters.app]),
    config() {
      return (
        this.app || { components: { googlelogin: false, azurelogin: true } }
      );
    },
    ...mapGetters(api.namespace, [api.getters.user]),
    user() {
      return this.$store.getters["users/user"];
    },
    error() {
      return {};
      //return this.$store.state.error;
    },
    loading() {
      return {};
      //return this.$store.state.loading;
    },
    adminview() {
      if (this.$route.query.admin) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.userSignIn,
      api.actions.userSignInWithGoogle
    ]),
    userSignMeIn() {
      this.userSignIn({
        email: this.email,
        password: this.password
      }).then(() => {
        console.log("Push the router!");
        // TODO: Warum wird hier nicht der router gepusht?
      });
    },
    userSignMeInWithGoogle() {
      this.userSignInWithGoogle();
    },
    userSignMeInWithAzure() {
      //TODO: Redirect URL ggf. aufbauen und ersetzen
      let redirectUrl = process.env.VUE_APP_AUTH_CONFIG;
      if (window.location.port === "5000") {
        // Adjust the requested redirectUri for local development
        redirectUrl =
          redirectUrl + "&redirect_uri=http%3A%2F%2Flocalhost%3A8080%2Fauth";
      }
      window.location.href = redirectUrl;
    }
  },
  watch: {
    user(value) {
      //console.log(value)
      if (value !== null && value !== undefined) {
        this.$router.push(this.$route.query.redirect || "/");
      }
    },
    error(value) {
      if (value) {
        this.alert = true;
      }
    },
    alert(value) {
      if (!value) {
        //this.$store.commit("setError", null);
      }
    }
  }
};
</script>
